// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./node_modules/@splidejs/splide/dist/js/splide.min.js");
